export default "__VITE_ASSET__b1e78ed9__"